<div class="recovery-modal-wrapper inner-modal-content">
    @if (currentStep === recoverySteps.Search) {
        <btl-modal-recovery-search (goToNextStep)="nextStep()" [forfait_bonus_reprise]="forfait_bonus_reprise" />
    }
    @if (currentStep === recoverySteps.Listing) {
        <btl-modal-recovery-listing
            (goToNextStep)="nextStep()"
            (goToPreviousStep)="previousStep()"
        ></btl-modal-recovery-listing>
    }
    @if (currentStep === recoverySteps.Result) {
        <btl-modal-recovery-result
            (goToNextStep)="closeModal()"
            (goToPreviousStep)="previousStep()"
            (goToSearchStep)="goToSearchStep()"
        ></btl-modal-recovery-result>
    }
</div>
